"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideDivider = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Swapper_1 = require("../Swapper");
var StopPropagation_1 = require("Common/Utils/StopPropagation");
var SideBySideDivider = function (_a) {
    var renderDragger = _a.renderDragger, forceShow = _a.forceShow, hideDragger = _a.hideDragger, renderSwapper = _a.renderSwapper, isDragging = _a.isDragging, onSwapperClick = _a.onSwapperClick, onDragStart = _a.onDragStart;
    var wrappedOnSwapperClick = function (event) {
        event.stopPropagation();
        onSwapperClick();
    };
    var draggerIsVisible = forceShow || isDragging;
    return (react_1.default.createElement("div", { className: "side-by-side__col-divider", contentEditable: false, "data-interactive-zone": true },
        (renderDragger || draggerIsVisible) && (react_1.default.createElement("div", { className: (0, classnames_1.default)("col-divider__dragger", { "col-divider__dragger--visible": draggerIsVisible }), onMouseDown: onDragStart },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("col-divider__line", {
                    "col-divider__line--dragging": isDragging,
                    "col-divider__line--hidden": hideDragger,
                }) }))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("col-divider__swapper-container", {
                "col-divider__swapper-container--force-show": forceShow,
            }) }, renderSwapper && (react_1.default.createElement(Swapper_1.SideBySideSwapper, { onClick: wrappedOnSwapperClick, onMouseDown: StopPropagation_1.stopPropagation, onMouseUp: StopPropagation_1.stopPropagation })))));
};
exports.SideBySideDivider = SideBySideDivider;
